import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API_URL = "https://live-evo.com/api";

function StaffSpamBotsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadSpamReports = async () => {
    try {
      setLoading(true);

      const res = await staffFetch(`${API_URL}/staff/private-message-spam`);
      const data = await res.json();

      if (data.success) {
        setItems(data.data || []);
      } else {
        alert(data.error || "Impossible de charger les spams MP.");
      }
    } catch (err) {
      console.log("Erreur StaffSpamBots:", err);
      alert("Erreur serveur.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSpamReports();
  }, []);

  const deleteSpamReport = async (id) => {
    const ok = window.confirm(
      "Supprimer ce signalement spam ?"
    );

    if (!ok) return;

    try {
      const res = await staffFetch(
        `${API_URL}/staff/private-message-spam/${id}`,
        {
          method: "DELETE"
        }
      );

      const data = await res.json();

      if (data.success) {
        setItems((prev) =>
          prev.filter((item) => item.id !== id)
        );
      } else {
        alert(data.error || "Suppression impossible.");
      }
    } catch (err) {
      console.log("Erreur suppression spam:", err);
      alert("Erreur serveur.");
    }
  };

  if (loading) {
    return (
      <div style={center}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={container}>
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <div style={header}>
          <button
            style={backButton}
            onClick={() => {
              window.location.href = "/staff";
            }}
          >
            ← Retour
          </button>

          <div style={title}>
            Anti-spam MP
          </div>

          <button
            style={refreshButton}
            onClick={loadSpamReports}
          >
            Rafraîchir
          </button>
        </div>

        <div style={subtitle}>
          Messages privés bloqués automatiquement
          par le bot anti-spam.
        </div>

        {items.length === 0 ? (
          <div style={emptyBox}>
            <div style={emptyTitle}>
              Aucun spam MP détecté
            </div>

            <div style={emptyText}>
              Les messages bloqués apparaîtront ici.
            </div>
          </div>
        ) : (
          items.map((item) => (
            <div
              key={item.id}
              style={card}
            >
              <div style={rowBetween}>
                <div style={badge}>
                  SPAM MP #{item.id}
                </div>

                <div style={date}>
                  {item.created_at
                    ? new Date(
                        item.created_at
                      ).toLocaleString("fr-FR")
                    : ""}
                </div>
              </div>

              <div style={label}>
                Expéditeur
              </div>

              <div style={value}>
                {item.sender_email}
              </div>

              <div style={label}>
                Destinataire
              </div>

              <div style={value}>
                {item.receiver_email}
              </div>

              <div style={label}>
                Raison
              </div>

              <div style={reason}>
                {item.reason || "Non précisée"}
              </div>

              <div style={label}>
                Message bloqué
              </div>

              <div style={message}>
                {item.message}
              </div>

              <button
                style={deleteButton}
                onClick={() =>
                  deleteSpamReport(item.id)
                }
              >
                Supprimer le signalement
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

const container = {
  minHeight: "100vh",
  background: "#05070d",
  color: "#fff",
  padding: 14
};

const header = {
  borderBottom:
    "1px solid rgba(0,242,255,0.18)",
  paddingBottom: 12,
  marginBottom: 14,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  flexWrap: "wrap"
};

const backButton = {
  background: "transparent",
  border: "none",
  color: "#00f2ff",
  fontWeight: "700",
  cursor: "pointer"
};

const title = {
  color: "#fff",
  fontSize: 22,
  fontWeight: "900"
};

const refreshButton = {
  background: "transparent",
  border: "1px solid #00f2ff",
  color: "#00f2ff",
  borderRadius: 10,
  padding: "8px 14px",
  fontWeight: "700",
  cursor: "pointer"
};

const subtitle = {
  color: "#8fa6ad",
  marginBottom: 20
};

const card = {
  background: "#0d111a",
  borderRadius: 16,
  border: "1px solid rgba(0,242,255,0.18)",
  padding: 14,
  marginBottom: 14
};

const rowBetween = {
  display: "flex",
  justifyContent: "space-between",
  gap: 10,
  marginBottom: 12,
  flexWrap: "wrap"
};

const badge = {
  color: "#05070d",
  background: "#00f2ff",
  borderRadius: 999,
  padding: "4px 10px",
  fontSize: 12,
  fontWeight: "900"
};

const date = {
  color: "#8fa6ad",
  fontSize: 11
};

const label = {
  color: "#8fa6ad",
  fontSize: 12,
  marginTop: 8,
  marginBottom: 2,
  fontWeight: "700"
};

const value = {
  color: "#fff",
  fontSize: 13
};

const reason = {
  color: "#ffcc00",
  fontSize: 14,
  fontWeight: "800"
};

const message = {
  color: "#fff",
  fontSize: 15,
  lineHeight: "21px",
  background: "#121827",
  borderRadius: 12,
  padding: 10,
  marginTop: 4
};

const deleteButton = {
  marginTop: 14,
  background: "#ff2d55",
  borderRadius: 12,
  padding: 12,
  border: "none",
  color: "#fff",
  fontSize: 14,
  fontWeight: "900",
  cursor: "pointer",
  width: "100%"
};

const center = {
  minHeight: "100vh",
  background: "#05070d",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#00f2ff"
};

const emptyBox = {
  marginTop: 80,
  textAlign: "center",
  padding: 20
};

const emptyTitle = {
  color: "#fff",
  fontSize: 18,
  fontWeight: "900",
  marginBottom: 8
};

const emptyText = {
  color: "#8fa6ad"
};

export default StaffSpamBotsPage;
